export default {
  privacy: 'https://www.remeha.nl/professional/algemeen/privacy-policy',
  terms: 'https://remeha.be/nl/over-remeha/algemene-informatie/gebruiksvoorwaarden/',
};



// WEBPACK FOOTER //
// ./js/lang/nl/links.js